module.exports = __webpack_public_path__ + "static/media/mq.8c1db4f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mq.svg
// module id = 195
// module chunks = 0